export const _baseURL = `${process.env.REACT_APP_API_URL || 'http://local:5000'}/api/v1`;
export const _notificationTemplate = `${_baseURL}/notification-template`
export const _getAllDiet = `${_baseURL}/view-my-diet-plan`;
export const _getDiet = `${_baseURL}/view-my-diet-plan/get-my-diet`;
export const _createDiet = `${_baseURL}/view-my-diet-plan/create`;
export const _getAllUsers = `${_baseURL}/users/get-all-users`
export const _updateUsers = `${_baseURL}/users`
export const _sendOTP = `${_baseURL}/users/auth/otp`
export const _VerifyOTP = `${_baseURL}/users/auth/otp/verify`
export const _loginwithpass = `${_baseURL}/users/auth/pass`
export const _getFeedbackRatings = `${_baseURL}/feedback-rating`
export const _dietTemplate = `${_baseURL}/diet-template`
export const _orders = `${_baseURL}/order`
export const _products = `${_baseURL}/product`
export const _category = `${_baseURL}/category/`
export const _banner = `${_baseURL}/banner`
export const _coupons =  `${_baseURL}/coupon`
export const _blog =  `${_baseURL}/blog`
export const _treatments =  `${_baseURL}/treatments`
export const _bookappointmentsbydoctor =  `${_baseURL}/book-appointments-by-doctor/total-treatment`